module.exports = __webpack_public_path__ + "img/zcsjk_icon_sand.592438f6.png";